module.exports = __webpack_public_path__ + "static/media/golden-boot-season-winner.4305f9c1.png";